import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportsComponent } from './reports.component';
import { AuthGuard } from '../shared/guards/auth.guard';
import { ReportsGuard } from '../shared/guards/reports.guard';
import { TermsGuard } from '../shared/guards/terms.guard';
import { LoansGuard } from '../shared/guards/loans.guard';

const routes: Routes = [
  { path: 'reports',
    component: ReportsComponent,
    children: [],
    canActivate: [AuthGuard, ReportsGuard, TermsGuard, LoansGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
